import React from 'react';
import PropTypes from 'prop-types';

import { NitroText } from 'nitro-components';
import styled from 'styled-components';
import { media } from '../../../utils/style-utils';
import image from '../../../assets/images/driver_safety_tile.svg';

const DriverSafety = styled.section`
  width: 100%;
  text-align: center;
`;

const Content = styled.div`
  font-size: 55px;
  color: ${props => props.theme.color.base1};
  margin-bottom: 20px;

  ${media.mobile`
      font-size: 20px;
      margin-bottom: 10px;
    `} ${media.tablet`
      font-size: 35px;
    `};
`;

const ImgContent = styled.div`
  width: 100%;
  margin-top: -80px;

  ${media.mobile`
      margin-top: -40px;
    `} ${media.tablet`
      margin-top: -60px;
    `};
`;

const InsightDriverSafety = ({ description, metric }) => (
  <DriverSafety>
    <img src={image} alt="" width="60%" />
    <Content>
      <ImgContent title={description}>{metric}</ImgContent>
    </Content>
    <NitroText size={3} variant="base1" bold>
      {description}
    </NitroText>
  </DriverSafety>
);

InsightDriverSafety.propTypes = {
  metric: PropTypes.number,
  description: PropTypes.string,
};

export default InsightDriverSafety;



// WEBPACK FOOTER //
// ./src/features/insights/components/InsightDriverSafety.js